import {useHistory} from '@aboutyou/router';
import React from 'react';
import styled from 'styled-components';
import {COLORS} from '../../../constants/colors';
import {Icon} from '../../atoms/Icon/Icon';
import {GenericIconName} from '../../atoms/Icon/IconName';
import {Image} from '../../atoms/Image/Image';
import {Text} from '../../atoms/Text/Text';

interface TopOneHundredImageProps {
  navigationUrl: string;
  title: string;
  imageText: string;
  image: string;
}

export const TopOneHundredImage = (props: TopOneHundredImageProps) => {
  const {navigationUrl, title, imageText, image} = props;
  const history = useHistory();

  const handleClick = () => {
    history.push(navigationUrl);
  };

  return (
    <Wrapper data-testid="topOneHundredImage">
      <NavigationHeader onClick={handleClick}>
        <Text size="px16" weight="bold">
          {title}
        </Text>

        <Icon asset={GenericIconName.ArrowLongRight} size="S" />
      </NavigationHeader>
      <ImageWrapper onClick={handleClick}>
        <Image src={image} ratio={'360:510'} breakpoints={[{width: '510'}]} />

        <ImageText size="px28" weight="heavy">
          {imageText}
        </ImageText>
      </ImageWrapper>
    </Wrapper>
  );
};

const ImageWrapper = styled.div`
  cursor: pointer;
`;

const ImageText = styled(Text)`
  line-height: 1.25;
  position: absolute;
  margin-top: 160px;
  left: 50%;
  transform: translateX(-50%);
  width: 250px;
`;

const NavigationHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
`;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
  padding: 20px 20px 0 20px;
  border-top: solid 1px ${COLORS.Grey3};
`;
